import { Switch } from '@shape-ds/components';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import './NotificationToggle.scss';
import { NotificationFrequency } from 'components/NotificationsManager/NotificationFrequency/NotificationFrequency';

export const NotificationToggle = () => {
  const { t } = useTranslation();
  const formMethods = useForm();
  return (
    <FormProvider {...formMethods}>
      <div className="notification-toggle-wrapper">
        <Controller
          name="isNotificationEnabled"
          render={({ field: { onChange, value } }) => {
            return (
              <div className="notification-toggle-switch">
                <Switch
                  onChange={(_e, checked) => onChange(checked)}
                  checked={value}
                  label={t('components:notifications_manager.notifications_list.toggle')}
                  labelPosition="end"
                />
              </div>
            );
          }}
        />
        <NotificationFrequency />
      </div>
    </FormProvider>
  );
};
